import { GetRequest, PostRequest } from "../service";

const ControllerName = 'OrderConversation'

export const GetMedicalOrderMessages = (orderId) => 
     GetRequest(`${ControllerName}/${orderId}`)

export const SendMedicalOrderMessage = (orderId ,requestBody)  => 
    PostRequest(`${ControllerName}/${orderId}`, requestBody)
